module.exports = __webpack_public_path__ + "img/tabs3.3bed2172.png";